/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function initCarouselTracking(element) {
        const mainSlider = jQuery(element);

        mainSlider.closest('.product__photos--beside').addClass('main-photo-holder');


    }

    function trackScrollStart() {
        window.removeEventListener('scroll', trackScrollStart);
    }

    function treatment() {
        Mojito.utils.waitForElement('.product__main-photos .slick-initialized', initCarouselTracking);
        window.addEventListener('scroll', trackScrollStart);
    }

    function trigger() {
        if (!/\/products\//gi.test(location.pathname) || !(Math.min(window.innerWidth, window.innerHeight) <= 768 && 'ontouchstart' in window)) {
            return;
        }

        treatment();
    }

    trigger();
})();
